<template>
	<div class="user flex main other_main">
		<asiden :asideData="asideList"></asiden>
		<div class="main_r">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import asiden from "../layout/aside/aside.vue";
export default {
	components: { asiden },
	name: "",
	data() {
		return {
			asideList: [
				{
					title: "全站数据",
					icon: "",
					router: "/webdata/pvuv",
					permissions: 201,
				},
				{
					title: "文章列表",
					icon: "",
					router: "/webdata/messageList",
					permissions: 202,
				},
				{
					title: "数据概览",
					icon: "",
					router: "/webdata/overview",
					permissions: 204,
				},
				{
					title: "专栏数据",
					icon: "",
					router: "/webdata/zloverview",
					permissions: 204,
				},
				{
					title: "AI内容占比",
					icon: "",
					router: "/webdata/aioverview",
					permissions: 204,
				},
				{
					title: "发布文章数",
					icon: "",
					router: "/webdata/articleCount",
					permissions: 204,
				},
			],
		};
	},
	mounted() {
		const role_permissions = this.$store.state.user.user.role_permissions; // 假设格式是 "100,200,300"
		if (role_permissions) {
			const permissionArray = role_permissions.split(",").map(Number); // 转换为数字数组
			this.asideList = this.asideList.filter((item) =>
				permissionArray.includes(item.permissions),
			);
		}
	},
};
</script>

<style scoped></style>
